module.exports = __webpack_public_path__ + "img/grading_notice_bg.7e6d4b2f.png";